<template>
  <div class="is-relative has-text-centered">
    <div class="has-text-weight-semibold is-size-6 m-b-15">
      <span>{{ $t('platformreferral.share-link-with-loved-one') }}</span>
    </div>
    <ButtonView type="is-primary" icon-left="cls-share" icon-pack="cls" @click="onShare">
      {{ $t('platformreferral.give-free-access') }}
    </ButtonView>
  </div>
</template>

<script>
import Lang from '/@/modules/core/app/services/Lang';
import { ReferralShareClickedEventTracking } from '/@/modules/platformreferral/segmentevents/ReferralShareClickedEventTracking';
import { PlatformReferralSegmentEventProperties } from '/@/modules/platformreferral/constants/PlatformReferralSegmentEventProperties';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'MobileReferralOption',
  components: { ButtonView },
  props: {
    referralLink: {
      type: String,
      required: true
    }
  },
  methods: {
    onShare() {
      ReferralShareClickedEventTracking.dispatch(
        PlatformReferralSegmentEventProperties.device.MOBILE,
        PlatformReferralSegmentEventProperties.medium.WEBSHARE
      );
      navigator.share({
        title: Lang.t('platformreferral.will-referral'),
        text: Lang.t('platformreferral.short-referral-message'),
        url: this.referralLink
      });
    }
  }
};
</script>
